// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3WjGI","card":"Cards_card__18fEy","infected":"Cards_infected__3dVXN","recovered":"Cards_recovered__1lI0g","deaths":"Cards_deaths__1Re3E"};